import { ReactNode } from 'react'
import { useApplicationContext } from '../../../provider'

interface ExperimentHocPropType {
  children: ReactNode
  experimentName: string
  control?: boolean
}

/**
 * Use this <ExperimentHoc> in MDX file to show content if we are in certain 'name' experiment
 * i.e. <ExperimentHoc experimentName='integrationBuilder'>Show Integration Builder</ExperimentHoc>
 *
 * For if/else condition when the experiment is on or off, you can use it like this
 *   <ExperimentHoc experimentName='A'>If case</ExperimentHoc>
 *   <ExperimentHoc experimentName='A' control>Else clause</ExperimentHoc>
 */
export const ExperimentHoc = ({
  children,
  experimentName,
  control = false,
}: ExperimentHocPropType) => {
  const { experiments } = useApplicationContext()

  // Special treatment check for experiment with more than one treatment
  switch (experimentName) {
    case 'integrationBuilder': {
      const treat1 = experiments.integrationBuilder || ''
      const treat2 = experiments.integrationBuilderKBYC || ''
      if (control && treat1.startsWith('Ctrl_') && treat1.startsWith('Ctrl_')) {
        return children
      } else if (
        !control &&
        (treat1.startsWith('Trmt_') || treat2.startsWith('Trmt_'))
      ) {
        return children
      }
      break
    }
    default: {
      const experiment = experiments[experimentName] || ''
      if (control && experiment.startsWith('Ctrl_')) {
        return children
      } else if (!control && experiment.startsWith('Trmt_')) {
        return children
      }
    }
  }

  return null
}

export default ExperimentHoc
